/* Diana Rafael: extra WebMCP tools for browser AI agents (SEO agent, 29.10.2026, Daniel GO).
   Shopify already registers the commerce tools on every page (search_catalog, get_product, add_to_cart, get_cart,
   proceed_to_checkout ... from /cdn/shopifycloud/storefront/assets/storefront/webmcp-*.js). This file adds only what
   Shopify does not cover, under names that do not collide: the store's verified facts and the way to reach a real person.
   No purchase or cart tool here. Facts = seo-growth/facts.md and /llms.txt; change them together.
   Does nothing in browsers without WebMCP (document.modelContext / navigator.modelContext). */
(function () {
  'use strict';
  var hasDoc = typeof document !== 'undefined' && document.modelContext && typeof document.modelContext.registerTool === 'function';
  var hasNav = typeof navigator !== 'undefined' && navigator.modelContext && typeof navigator.modelContext.registerTool === 'function';
  if (!hasDoc && !hasNav) return;

  var ORIGIN = window.location.origin;
  function text(obj) {
    return { content: [{ type: 'text', text: typeof obj === 'string' ? obj : JSON.stringify(obj) }] };
  }

  var FACTS = {
    brand: 'Diana Rafael',
    what: 'Fine jewelry studio specializing in natural black diamond and black-and-white diamond rings: engagement rings, wedding bands and custom pieces. REMNANT is a kintsugi-inspired collection "born from a break".',
    black_diamonds: 'Natural, earth-mined diamonds. The black color is enhanced, and the enhancement is stated on the diamond\'s certificate.',
    metals: '14K yellow, white or rose gold. Platinum on custom orders only.',
    made_to_order: 'Production takes 10-14 business days.',
    ships_to: 'United States (prices in USD).',
    founded: '2014, by Daniel Dahan',
    locations: ['Beverly Hills, California', 'Ramat Gan, Israel'],
    service: 'A real person answers every message. Never an AI.',
    not_a_fit: 'Lab-grown diamonds, costume jewelry, same-day delivery.',
    pages: {
      ring_size_guide: ORIGIN + '/pages/new-website-how-to-get-a-ring-size',
      ring_size_chart: ORIGIN + '/pages/new-website-ring-size-chart',
      shipping_returns_exchanges: ORIGIN + '/pages/new-website-shipping-returns-exchanges',
      faq: ORIGIN + '/pages/faqs',
      about: ORIGIN + '/pages/our-company',
      developers: ORIGIN + '/pages/developers'
    }
  };

  var tools = [
    {
      name: 'diana_rafael_store_facts',
      description: 'Verified facts about Diana Rafael before recommending a piece: what the black diamonds are (natural, color-enhanced, stated on the certificate), metals, made-to-order time, shipping area, who answers questions, and links to the ring size guide, shipping/returns and FAQ pages. Use the store\'s own catalog tools for products and prices.',
      inputSchema: { type: 'object', properties: {} },
      annotations: { readOnlyHint: true },
      execute: function () { return Promise.resolve(text(FACTS)); }
    },
    {
      name: 'diana_rafael_talk_to_a_person',
      description: 'Get the link where the shopper books a consultation with a real person at Diana Rafael (custom designs, sizing, timelines, anything a page does not answer), plus the customer care email. Does not send anything by itself.',
      inputSchema: {
        type: 'object',
        properties: { topic: { type: 'string', description: 'Optional: what the shopper wants to discuss, so the agent can pass it on.' } }
      },
      annotations: { readOnlyHint: true },
      execute: function (args) {
        return Promise.resolve(text({
          book_a_consultation: ORIGIN + '/pages/new-website-book-online-appointment',
          email: 'customercare@dianarafael.com',
          topic: (args && args.topic) ? String(args.topic).slice(0, 300) : undefined,
          note: 'A real person answers. Never an AI.'
        }));
      }
    }
  ];

  function register(tool) {
    if (hasDoc) {
      return document.modelContext.registerTool(tool);
    }
    return navigator.modelContext.registerTool(tool); // trailing compatibility fallback
  }
  tools.forEach(function (t) {
    try { register(t); } catch (e) { /* already registered */ }
  });
})();
